import { render, staticRenderFns } from "./SaleMonitoring.vue?vue&type=template&id=5bcbfaa3&scoped=true&"
import script from "./SaleMonitoring.vue?vue&type=script&lang=js&"
export * from "./SaleMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./SaleMonitoring.vue?vue&type=style&index=0&id=5bcbfaa3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcbfaa3",
  null
  
)

export default component.exports